import { TutorialCarousel } from './components/TutorialCarousel'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

function TutorialDialog({ open, setOpen }: CommonDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        contentVerticalPosition="bottom"
        className="[&>button]:-mt-3 [&>button]:-mr-3 flex flex-col justify-center p-4 pt-10"
      >
        <TutorialCarousel />
      </DialogContent>
    </Dialog>
  )
}

export const tutorialDialogConfig: DialogConfig<CommonDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: TutorialDialog,
  name: 'TutorialDialog',
}
